import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApplicationService, } from './application.service';
import { ApplicationTypes, RatecardDetails } from '@portal-workspace/grow-shared-library';
import { Observable } from 'rxjs';
import { User } from '@portal-workspace/grow-shared-library';
import { getUser } from '@portal-workspace/grow-ui-library';
import { map } from 'rxjs/operators';
import { ApplicationDialogService } from '@portal-workspace/grow-ui-library';
import { Router } from '@angular/router';
import { PortalHotToastService } from '@portal-workspace/grow-ui-library';
import { inject } from '@angular/core';

export abstract class AbstractRatecardResolver  {

  hotToastService: PortalHotToastService = inject(PortalHotToastService);

  constructor(private applicationService: ApplicationService,
    private dialogService: ApplicationDialogService,
    private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RatecardDetails | null> | Promise<RatecardDetails | null> | RatecardDetails | null {
    const user: User | null = getUser();
    if (user) {
      if (user.OriginatorBusinessId !== null) {
        return this.applicationService.getRatecardDetails(user.UserId, this.type()).pipe(
          this.hotToastService.spinnerObservable(),
          map(r => {
            console.log(`******* ratecard ${this.type()} resolver`, r.payload);
            return r.payload
          }),
        );
      } else {
        return this.applicationService.getDefaultRatecardDetails(this.type()).pipe(
          map(r => {
            console.log(`******* ratecard ${this.type()} resolver`, r.payload);
            return r.payload
          }),
        );
      }
    }
    return null;
  }

  abstract type(): ApplicationTypes;

}
